import React, { useState } from 'react'
import axios from 'axios'
import Cookies from 'js-cookie'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { login } from '../redux/authentication/actionCreator'
import { setItem } from '../utility/localStorageControl'
import { F, PISMO, PISMO_NADPIS, GlobalneMobil } from './styl'

// Prihlasenie pre telefon.
//
// Desktopova administracia ma vlastne prihlasenie v container/profile/
// authentication. Jeho rozlozenie ale na uzkej obrazovke poskladá logo,
// nadpis a velku fotku auta NAD formular, takze na telefone clovek vidi
// peknu stranku a ziadne policka, kym neodroluje. Preto tu je vlastna
// obrazovka. Samotne prihlasenie je to iste volanie a ta ista redux
// akcia ako na pocitaci, len obal je iny.
//
// Po uspesnom prihlaseni sa nikam nepresmerovava. Adresa uz je spravna
// (clovek prisiel na /mobil/kalendar), takze len co redux prepne stav,
// vykresli sa priamo ta obrazovka, na ktoru sel.

const Plocha = styled.div`
  min-height: 100vh;
  background: ${F.pozadie};
  color: ${F.text};
  font-family: ${PISMO};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px 20px calc(24px + env(safe-area-inset-bottom, 0px));
`

const Znacka = styled.div`
  text-align: center;
  margin-bottom: 28px;

  img {
    width: 54px;
    height: 54px;
    border-radius: 12px;
    display: block;
    margin: 0 auto 14px;
  }

  h1 {
    margin: 0;
    font-family: ${PISMO_NADPIS};
    font-weight: 400;
    font-size: 30px;
    line-height: 1.05;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${F.text};
  }

  p {
    margin: 4px 0 0;
    font-size: 14px;
    color: ${F.textSlaby};
  }
`

const Formular = styled.form`
  background: ${F.biela};
  border: 1px solid ${F.ciara};
  border-radius: 8px;
  padding: 18px 16px 20px;

  label {
    display: block;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${F.textSlaby};
    margin-bottom: 6px;
  }

  /* 16px naschval: pri mensom pisme iOS pri pisani sam priblizi stranku. */
  input {
    width: 100%;
    height: 48px;
    padding: 0 12px;
    margin-bottom: 14px;
    border: 1px solid ${F.ciara};
    border-radius: 6px;
    background: ${F.biela};
    color: ${F.text};
    font-family: ${PISMO};
    font-size: 16px;

    &:focus {
      outline: none;
      border-color: ${F.hlavna};
    }
  }
`

const Tlacidlo = styled.button`
  width: 100%;
  height: 50px;
  margin-top: 4px;
  border: none;
  border-radius: 6px;
  background: ${F.hlavna};
  color: #fff;
  font-family: ${PISMO};
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
  }

  &:active:not(:disabled) {
    background: ${F.hlavnaTmava};
  }
`

const Chyba = styled.p`
  margin: 0 0 14px;
  padding: 10px 12px;
  border: 1px solid #f5c6cc;
  border-radius: 6px;
  background: #fde6e9;
  color: ${F.hlavnaTmava};
  font-size: 14px;
`

const Pata = styled.p`
  margin: 18px 0 0;
  text-align: center;
  font-size: 13px;
  color: ${F.textSlaby};
`

const Prihlasenie = () => {
  const dispatch = useDispatch()
  const [email, setEmail] = useState('')
  const [heslo, setHeslo] = useState('')
  const [chyba, setChyba] = useState('')
  const [posielam, setPosielam] = useState(false)

  const odosli = async e => {
    e.preventDefault()
    if (posielam) return
    setChyba('')
    setPosielam(true)
    try {
      const odpoved = await axios({
        method: 'post',
        url:
          process.env.REACT_APP_BACKEND_API_URL +
          '/user/login?apikey=' +
          process.env.REACT_APP_TOKEN_API,
        headers: { 'Content-Type': 'application/json' },
        data: JSON.stringify({ email, password: heslo })
      })
      const vysledok = odpoved?.data
      if (vysledok?.code === 200 && vysledok?.user) {
        const pouzivatel = vysledok.user
        setItem('user', pouzivatel)
        Cookies.set('branchOfficeId', pouzivatel?.branchOffice?.id)
        Cookies.set('userRole', pouzivatel?.role)
        // Tu sa stav neprepne hned, redux akcia caka sekundu. Tlacidlo
        // preto ostava zamknute, nech sa to neodosle druhy raz.
        dispatch(login())
        return
      }
      setChyba('Nesprávny e-mail alebo heslo.')
    } catch (nieco) {
      setChyba('Nedá sa spojiť so serverom. Skús to znova.')
    }
    setPosielam(false)
  }

  return (
    <>
      <GlobalneMobil />
      <Plocha>
        <Znacka>
          <img src='/logo192.png' alt='' />
          <h1>Pneusystem</h1>
          <p>Kalendár, zákazky a uskladnenie</p>
        </Znacka>

        <Formular onSubmit={odosli}>
          {chyba ? <Chyba>{chyba}</Chyba> : null}

          <label htmlFor='ps-email'>E-mail</label>
          <input
            id='ps-email'
            type='email'
            name='email'
            autoComplete='username'
            autoCapitalize='none'
            autoCorrect='off'
            inputMode='email'
            value={email}
            onChange={e => setEmail(e.target.value)}
          />

          <label htmlFor='ps-heslo'>Heslo</label>
          <input
            id='ps-heslo'
            type='password'
            name='password'
            autoComplete='current-password'
            value={heslo}
            onChange={e => setHeslo(e.target.value)}
          />

          <Tlacidlo type='submit' disabled={posielam}>
            {posielam ? 'Prihlasujem' : 'Prihlásiť sa'}
          </Tlacidlo>
        </Formular>

        <Pata>To isté meno a heslo ako v administrácii na počítači.</Pata>
      </Plocha>
    </>
  )
}

export default Prihlasenie
